import { Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { COMMON_STRING } from '@/constants/dictionary';
import { CustomTooltip } from '../StatsCompareTable/StyledStatsComponents';

type Props = {
  photoUrl?: string | null;
  userId?: string | null;
};

export const ScorerAvatar = ({ photoUrl, userId }: Props) => {
  return (
    <CustomTooltip
      title={
        photoUrl
          ? COMMON_STRING.TAP_TO_ENLARGE
          : COMMON_STRING.PHOTO_NOT_AVAILABLE
      }
    >
      <Avatar
        src={photoUrl ?? undefined}
        data-role='scorer-avatar'
        data-user-id={userId}
        sx={{
          width: 30,
          height: 30,
          alignSelf: 'center',
          cursor: photoUrl ? 'pointer' : 'default',
          '&:hover': photoUrl ? { opacity: 0.8 } : undefined,
        }}
      >
        {!photoUrl && <PersonIcon />}
      </Avatar>
    </CustomTooltip>
  );
};
